export default __webpack_public_path__ + "static/media/ATRAS.84fad7db.png";